'use client';

import { useQuery } from '@tanstack/react-query';

import Pagination from '@/components/shared/Pagination';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useScrollIntoViewOnChange } from '@/hooks/useScrollIntoViewOnChange';
import { cn } from '@/utils/cn';
import { ProviderListContent } from './components/ProviderListContent';
import {
  providerListQueryOptions,
  PROVIDERS_LIST_DESKTOP_PAGE_SIZE,
} from './providerList.queries';

interface ProviderListProps {
  className?: string;
  search: string;
  page: number;
  onSetPage?: (page: number) => void;
}

export default function ProviderList({ className, search, page, onSetPage }: ProviderListProps) {
  const sectionRef = useScrollIntoViewOnChange(page);
  const isMobile = useMediaQuery('(max-width: 768px)');
  const pageSizes = isMobile ? 10 : PROVIDERS_LIST_DESKTOP_PAGE_SIZE;

  const { data: providersData, isFetching } = useQuery(providerListQueryOptions({
    page,
    search,
    limit: pageSizes,
  }));

  const pageSize = providersData?.totalPages || pageSizes;
  const totalItems = providersData?.totalItems || 0;

  return (
    <section ref={sectionRef} className={cn('scroll-m-25', className)}>

      <div className="relative w-full">

        <ProviderListContent
          isFetching={isFetching}
          defaultPageSize={pageSizes}
          items={providersData?.items}
        />

      </div>
      {
        totalItems > pageSizes && (
          <Pagination
          // TODO: add variant link
            totalPages={pageSize}
            totalItems={totalItems}
            onPageChangeAction={onSetPage}
            className="mt-4.5! md:mt-12! md:ml-0"
            pageNumber={providersData?.page || 1}
          />
        )
      }

    </section>
  );
};
